import {
  LoginPageWrapper,
  LoginInfoWrapper,
  LoginTitle,
  LoginDescription,
  LoginWarningMessage,
  LoginButton,
} from "./style";

const Login = (props) => {
  const { onLogin } = props;

  return (
    <LoginPageWrapper>
      <LoginInfoWrapper>
        <LoginTitle>Log in</LoginTitle>
        <LoginDescription>구글 계정을 이용하여 로그인 합니다.</LoginDescription>
        <LoginWarningMessage>
          파이어 베이스를 이용하여 구글 계정을 로그인에만 이용할 뿐 안심하셔도
          괜찮습니다.
          <br /> 구글 계정을 통한 로그인을 원치 않으시면 <br />
          비회원으로 서비스를 이용하실 수 있습니다. (카드 저장은 불가)
        </LoginWarningMessage>
      </LoginInfoWrapper>
      <LoginButton className="login-btn" onClick={onLogin}>
        구글 계정으로 로그인
      </LoginButton>
    </LoginPageWrapper>
  );
};

export default Login;
